import * as platform from './platform/index.js';
import * as identity from './identity/index.js';
import * as billing from './billing/index.js';
import * as engagement from './engagement/index.js';
import * as audit from './audit/index.js';
import * as assistant from './assistant/index.js';
export { platform };
export { identity };
export { billing };
export { engagement };
export { audit };
export { assistant };
/** Every route of every context with a contract, in manifest order. */
export const allRoutes = [
    ...platform.routes,
    ...identity.routes,
    ...billing.routes,
    ...engagement.routes,
    ...audit.routes,
    ...assistant.routes,
];
/** Every assistant tool of every context with a contract. */
export const allTools = [
    ...platform.tools,
    ...identity.tools,
    ...billing.tools,
    ...engagement.tools,
    ...audit.tools,
    ...assistant.tools,
];
/** Contexts that have a contract (stubs are not listed). */
export const contractContexts = [
    'platform',
    'identity',
    'billing',
    'engagement',
    'audit',
    'assistant',
];
//# sourceMappingURL=index.js.map